/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Details_Member_Seat_Type_Changed_DescInputs */



/**
* | output |
* | --- |
* | "The member's seat type went up and took effect now: an empty seat of the new type was used, or a new seat was bought and charged for the rest of the billing ..." |
*
* @param {Audit_Details_Member_Seat_Type_Changed_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_member_seat_type_changed_desc = /** @type {((inputs?: Audit_Details_Member_Seat_Type_Changed_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Member_Seat_Type_Changed_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Sitztyp des Mitglieds wurde erhöht und gilt ab sofort: Es wurde ein freier Sitz des neuen Typs genutzt oder ein neuer Sitz gekauft und für den Rest des Abrechnungszeitraums berechnet. Der bisherige Sitz bleibt bis zur nächsten Verlängerung bezahlt.")
	return /** @type {LocalizedString} */ ("The member's seat type went up and took effect now: an empty seat of the new type was used, or a new seat was bought and charged for the rest of the billing period. The seat they left stays paid until the next renewal.")
});